import { useI18n } from '@udemy/i18n';
import { AI_LEARNING_NAV } from '../browse-constants';
import { useHeaderStore } from './use-header-store';
export const useAILearningNav = () => {
  const {
    gettext
  } = useI18n();
  const headerStore = useHeaderStore();
  const showLearnAINavigation = headerStore.isLearnAINavigationFeatureEnabled;
  return {
    aiLearningNav: AI_LEARNING_NAV(gettext),
    showLearnAINavigation
  };
};
//# sourceMappingURL=use-ai-learning-nav.js.map